module.exports = __webpack_public_path__ + "static/img/4.758d890.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/zh/4.png
// module id = Ypl3
// module chunks = 0